module.exports = __webpack_public_path__ + "static/img/guide-betting-method.60b9a10.png";